import CalendarService from './calendar/calendar-service';
import ClientService from './client/client-service';
import DomainService from './billing/domain-service';
import InvoiceService from './billing/invoice-service';
import JobService from './job/job-service';
import MicroServiceServiceContainer from '@vertical-plus/vue-js-micro-service-components/lib/model/service/service-container';
import OmnisearchService from './search/omnisearch-service';
import ReportService from './report/report-service';
import ServiceService from './billing/service-service';
import SiteService from './ecommerce/site-service';
import StoreInterface from '@vertical-plus/vue-js-micro-service-components/lib/store/store-interface';
import TagService from './taxonomy/tag-service';
import TechspecService from './job/techspec-service';
import TimesheetService from './audit/timesheet-service';
import UserService from './organisation/user-service';

export default class ServiceContainer extends MicroServiceServiceContainer
{
    private _calendarService!: CalendarService;
    private _clientService!: ClientService;
    private _domainService!: DomainService;
    private _invoiceService!: InvoiceService;
    private _jobService!: JobService;
    private _omnisearchService!: OmnisearchService;
    private _appReportService!: ReportService;
    private _appTagService!: TagService;
    private _serviceService!: ServiceService;
    private _siteService!: SiteService;
    private _techspecService!: TechspecService;
    private _timesheetService!: TimesheetService;
    private _appUserService!: UserService;

    public constructor(store: StoreInterface)
    {
        super();

        this.store = store;
    }

    /**
     * Returns the calendar service
     */

    public get calendarService(): CalendarService
    {
        if (!this._calendarService)
        {
            this._calendarService = new CalendarService(this.store, this.authenticationService);
        }

        return this._calendarService;
    }

    /**
     * Returns the client service
     */

    public get clientService(): ClientService
    {
        if (!this._clientService)
        {
            this._clientService = new ClientService(this.store, this.authenticationService);
        }

        return this._clientService;
    }

    /**
     * Returns the domain service
     */

    public get domainService(): DomainService
    {
        if (!this._domainService)
        {
            this._domainService = new DomainService(this.store, this.authenticationService);
        }

        return this._domainService;
    }

    /**
     * Returns the invoice service
     */

    public get invoiceService(): InvoiceService
    {
        if (!this._invoiceService)
        {
            this._invoiceService = new InvoiceService(this.store, this.authenticationService);
        }

        return this._invoiceService;
    }

    /**
     * Returns the job service
     */

    public get jobService(): JobService
    {
        if (!this._jobService)
        {
            this._jobService = new JobService(this.store, this.authenticationService);
        }

        return this._jobService;
    }

    /**
     * Returns the omnisearch service
     */

    public get omnisearchService(): OmnisearchService
    {
        if (!this._omnisearchService)
        {
            this._omnisearchService = new OmnisearchService(this.store, this.authenticationService);
        }

        return this._omnisearchService;
    }

    /**
     * Returns the report service
     */

    public get appReportService(): ReportService
    {
        if (!this._appReportService)
        {
            this._appReportService = new ReportService(this.store, this.authenticationService);
        }

        return this._appReportService;
    }

    /**
     * Returns the service service
     */

    public get serviceService(): ServiceService
    {
        if (!this._serviceService)
        {
            this._serviceService = new ServiceService(this.store, this.authenticationService);
        }

        return this._serviceService;
    }

    /**
     * Returns the tag service
     */

    public get tagService(): TagService
    {
        if (!this._appTagService)
        {
            this._appTagService = new TagService(this.store, this.authenticationService);
        }

        return this._appTagService;
    }

    /**
     * Returns the site service
     */

    public get siteService(): SiteService
    {
        if (!this._siteService)
        {
            this._siteService = new SiteService(this.store, this.authenticationService);
        }

        return this._siteService;
    }

    /**
     * Returns the techspec service
     */

    public get techspecService(): TechspecService
    {
        if (!this._techspecService)
        {
            this._techspecService = new TechspecService(this.store, this.authenticationService);
        }

        return this._techspecService;
    }

    /**
     * Returns the timesheet service
     */

    public get timesheetService(): TimesheetService
    {
        if (!this._timesheetService)
        {
            this._timesheetService = new TimesheetService(this.store, this.authenticationService);
        }

        return this._timesheetService;
    }

    /**
     * Returns the user service
     */

    public get userService(): UserService
    {
        if (!this._appUserService)
        {
            this._appUserService = new UserService(this.store, this.authenticationService);
        }

        return this._appUserService;
    }
}